var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckSolidOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_52926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19C10.1217 19 12.1566 18.1571 13.6569 16.6569C15.1571 15.1566 16 13.1217 16 11C16 8.87827 15.1571 6.84344 13.6569 5.34315C12.1566 3.84285 10.1217 3 8 3C5.87827 3 3.84344 3.84285 2.34315 5.34315C0.842855 6.84344 0 8.87827 0 11C0 13.1217 0.842855 15.1566 2.34315 16.6569C3.84344 18.1571 5.87827 19 8 19ZM11.5312 9.53125L7.53125 13.5312C7.2375 13.825 6.7625 13.825 6.47188 13.5312L4.47188 11.5312C4.17813 11.2375 4.17813 10.7625 4.47188 10.4719C4.76562 10.1813 5.24062 10.1781 5.53125 10.4719L7 11.9406L10.4688 8.46875C10.7625 8.175 11.2375 8.175 11.5281 8.46875C11.8187 8.7625 11.8219 9.2375 11.5281 9.52812L11.5312 9.53125Z",
    fill: "#FF5C39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_52926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckSolidOrange);
export default __webpack_public_path__ + "static/media/circle-check-solid-orange.1bbf956ca752db5afed0a81f0cc7f1b5.svg";
export { ForwardRef as ReactComponent };